import React, { useEffect, useState } from "react";
import { postApi, putApi } from "../../AppApis";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Header from "../../Header/Header";
import { FaRegEdit } from "react-icons/fa";
import SettingHeader from "../../../components/SettingPageHeader/SettingHeader";
import styles from "./SecuritySettings.module.css";
import { showErrorToast, showSuccessToast } from "../../utils";
import { useProfile } from "../../../contexts/ProfileContext";
export default function ChangeEmail() {
    const navigate = useNavigate(); // Initialize the navigate function
    const { profileData, fetchProfile } = useProfile();
    const [isLoading, setIsLoading] = useState(false);
    const [payload, setPayload] = useState({
        old_email: profileData?.email,
        new_email: "",
    });
    const [currentStep, setCurrentStep] = useState(0);
    const [sessionToken, setSessionToken] = useState(null);
    const [Otp, setOtp] = useState(null);
    useEffect(() => {
        setPayload((prev) => ({
            ...prev,
            old_email: profileData?.email,
        }));
    }, [profileData]);

    const emailRegx = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const handleButtonClick = async () => {
        if (!payload.old_email || !payload.new_email) {
            alert("Please fill all fields");
            return;
        } else if (!emailRegx.test(payload.new_email)) {
            alert("Please enter a valid email address (e.g., example@domain.com)");
        }
        if (payload?.new_email === payload.old_email) {
            alert("New Email and old Email should be different");
            return;
        }
        const object = {
            current_email: payload.old_email,
            new_email: payload.new_email,
        };
        setIsLoading(true);
        try {
            const response = await postApi("/user/initiate-email-change", object);
            if (response.error) {
                showErrorToast(response.error.detail || response.error, {
                    autoClose: 3000,
                    pauseOnHover: false,
                });
            } else {
                setSessionToken(response.response.session_token);
                showSuccessToast(`Otp sent to ${payload.old_email}. Please verify it.`, {
                    autoClose: 3000,
                    pauseOnHover: false,
                });
                setCurrentStep(1);
                setOtp("");
            }
        } catch (error) {
            console.error(error);
        }
        setIsLoading(false);
    };
    const SubmitOtp = async () => {
        if (!Otp) {
            alert("Please fill all fields");
            return;
        }
        try {
            const object = {
                current_email: payload.old_email,
                otp_code: Otp,
                new_email: payload.new_email,
            };

            const response = await postApi("/user/verify-old-email-otp", object);
            if (response.error) {
                showErrorToast(response.error.detail || response.error, {
                    autoClose: 3000,
                    pauseOnHover: false,
                });
            } else {
                setSessionToken(response.response.session_token);
                setOtp("");
                showSuccessToast(`Otp sent to ${payload.new_email}. Please verify it.`);
                setCurrentStep(2);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const submitNewEmailOtp = async () => {
        if (!Otp) {
            alert("Please fill all fields");
            return;
        }
        try {
            const newobject = {
                new_email: payload.new_email,
                otp_code: Otp,
                session_token: sessionToken,
            };
            const res = await postApi("/user/verify-new-email-otp", newobject);
            if (res.error) {
                showErrorToast(res.error.detail || res.error, {
                    autoClose: 3000,
                    pauseOnHover: false,
                });
            } else {
                showSuccessToast(`Email changed successfully`, {
                    autoClose: 3000,
                    pauseOnHover: false,
                });
                fetchProfile();
                navigate("/properties");
            }
        } catch (error) {}
    };
    return (
        <>
            <Header title="Change Email" />
            <div className="tw-p-[20px]">
                <SettingHeader title="Change Email" />
                <div className="tw-p-[20px] tw-text-black tw-w-full tw-items-center tw-flex tw-flex-col ">
                    {currentStep === 0 && (
                        <div className="tw-flex tw-flex-col tw-gap-4 tw-mt-10 tw-w-full lg:tw-w-[70%] tw-bg-white tw-rounded-xl tw-p-[20px]">
                            <div>
                                <p className="tw-text-sm tw-font-medium tw-mb-1">Current Email</p>
                                <div className="tw-relative  tw-rounded-md">
                                    <input
                                        value={payload.old_email}
                                        disabled
                                        type="text"
                                        placeholder="example@gmail.com"
                                        className="tw-w-full tw-text-[14px] tw-h-[45px] tw-bg-white tw-border tw-border-gray-300 tw-mt-2 tw-px-4 tw-py-2 tw-rounded-md tw-pr-10"
                                    />
                                </div>
                            </div>
                            <div>
                                <p>New Email</p>
                                <input
                                    value={payload.new_email}
                                    onChange={(e) => setPayload({ ...payload, new_email: e.target.value })}
                                    type="email"
                                    placeholder="Enter your new email"
                                    className="tw-w-full tw-h-[45px] tw-text-[14px] tw-bg-white tw-border tw-border-background_secondary_color tw-mt-2 tw-px-4 tw-py-2 tw-rounded-md"
                                />
                            </div>

                            <div className="tw-flex tw-justify-center">
                                <button
                                    onClick={handleButtonClick}
                                    className="tw-bg-primary hover:tw-bg-primary_hover tw-font-Space_Grotesk tw-w-fit tw-p-1 tw-px-4 2xl:tw-text-[22px] between:tw-text-[18px] tw-rounded-md tw-text-white tw-flex tw-items-center tw-gap-1 tw-justify-center tw-mb-2 tw-mt-1 2xl:tw-mt-4 2xl:tw-mb-6"
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    )}
                    {currentStep === 1 && (
                        <div className="tw-flex tw-flex-col tw-gap-4 tw-mt-10 tw-w-full lg:tw-w-[70%] tw-bg-white tw-rounded-xl tw-p-[20px]">
                            <div>
                                <p className="tw-text-sm tw-font-medium tw-mb-1">Enter OTP</p>
                                <div className="tw-relative  tw-rounded-md">
                                    <input
                                        value={Otp}
                                        type="text"
                                        placeholder="Enter OTP"
                                        onChange={(e) => setOtp(e.target.value)}
                                        className="tw-w-full tw-text-[14px] tw-h-[45px] tw-bg-white tw-border tw-border-gray-300 tw-mt-2 tw-px-4 tw-py-2 tw-rounded-md tw-pr-10"
                                    />
                                </div>
                            </div>

                            <div className="tw-flex tw-justify-center">
                                <button
                                    onClick={SubmitOtp}
                                    className="tw-bg-primary hover:tw-bg-primary_hover tw-font-Space_Grotesk tw-w-fit tw-p-1 tw-px-4 2xl:tw-text-[22px] between:tw-text-[18px] tw-rounded-md tw-text-white tw-flex tw-items-center tw-gap-1 tw-justify-center tw-mb-2 tw-mt-1 2xl:tw-mt-4 2xl:tw-mb-6"
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                    )}
                    {currentStep === 2 && (
                        <div className="tw-flex tw-flex-col tw-gap-4 tw-mt-10 tw-w-full lg:tw-w-[70%] tw-bg-white tw-rounded-xl tw-p-[20px]">
                            <div>
                                <p className="tw-text-sm tw-font-medium tw-mb-1">Enter OTP</p>
                                <div className="tw-relative  tw-rounded-md">
                                    <input
                                        value={Otp}
                                        type="text"
                                        placeholder="Enter OTP"
                                        onChange={(e) => setOtp(e.target.value)}
                                        className="tw-w-full tw-text-[14px] tw-h-[45px] tw-bg-white tw-border tw-border-gray-300 tw-mt-2 tw-px-4 tw-py-2 tw-rounded-md tw-pr-10"
                                    />
                                </div>
                            </div>

                            <div className="tw-flex tw-justify-center">
                                <button
                                    onClick={submitNewEmailOtp}
                                    className="tw-bg-primary hover:tw-bg-primary_hover tw-font-Space_Grotesk tw-w-fit tw-p-1 tw-px-4 2xl:tw-text-[22px] between:tw-text-[18px] tw-rounded-md tw-text-white tw-flex tw-items-center tw-gap-1 tw-justify-center tw-mb-2 tw-mt-1 2xl:tw-mt-4 2xl:tw-mb-6"
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}
